import { FC } from 'react';
import { useSelector } from 'react-redux';

import { cn } from '@distribute/frontend/utils';

import { SelectOptionUser } from '../../../../shared/ui/select';
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
} from '../../../../shared/ui/select/SelectV2';

import { UserToTeamRole } from '@distribute/shared/types';
import { teamsModel } from '../../../teams';
import { authUserModel } from '../../../../entities/auth-user';
import { IconMap } from '../../../../shared/sprite';
import { Icon } from '../../../../shared/ui';

export const ALL_OWNERS = 'all';

type Props = {
  value?: 'all' | string;
  onChange: (value: string) => void;
  className?: string;
};

export const SelectMember: FC<Props> = ({
  value = ALL_OWNERS,
  onChange,
  className,
}) => {
  const currentUser = useSelector(authUserModel.selectors.selectUserWithError);

  const teamMembers = useSelector(
    teamsModel.selectors.selectCurrentTeamMembers
  );
  const selectedMember = teamMembers.find(
    (member) => member.user?.id === value
  );

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        className={cn('sm:w-full w-45', className)}
        classNameValue="flex flex-nowrap items-center gap-x-1"
      >
        {value === ALL_OWNERS ? (
          <>
            <Icon
              glyph={IconMap.Members}
              width={20}
              className="flex-shrink-0"
            />
            <span className="truncate">All owners</span>
          </>
        ) : (
          <SelectOptionUser
            displayName={selectedMember?.user?.displayName ?? ''}
            photoUrl={selectedMember?.user?.photoUrl}
            email={selectedMember?.user?.email}
          />
        )}
      </SelectTrigger>
      <SelectContent
        side="bottom"
        align="start"
        sideOffset={4}
        className="w-90"
        showIcon
      >
        <SelectItem
          value={ALL_OWNERS}
          key={ALL_OWNERS}
          className="pl-2"
          classNameValue="flex items-center gap-x-2"
        >
          <Icon
            glyph={IconMap.Members}
            width={20}
            className="flex-shrink-0 text-gray-500"
          />
          <span className="truncate">All owners</span>
        </SelectItem>
        {teamMembers
          .filter(
            (member) =>
              member.role !== UserToTeamRole.GUEST &&
              member.user &&
              !member.isWaitingForInviteAcceptance
          )
          .map((member) => (
            <SelectItem
              className="pl-2"
              value={member.user?.id || ''}
              key={member.user?.id || ''}
            >
              <SelectOptionUser
                isCurrentUser={currentUser?.id === member.user?.id}
                displayName={member.user?.displayName ?? ''}
                photoUrl={member.user?.photoUrl}
                email={member.user?.email}
              />
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  );
};
